import React, { useEffect, useState } from 'react';
import { Link, scroller } from 'react-scroll';
import ImageComponent from 'atoms/Image';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';

const ScrollTop = props => {
  const { showThreshold = 300 } = props;
  const { GoTop } = IMAGE_PATH;
  const [scrolling, setScrolling] = useState(false);
  const [scrollTop, setScrollTop] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      let crntPos = document.documentElement.scrollTop;
      if (crntPos < showThreshold) {
        // downscroll code
        setScrolling(false);
      } else {
        // upscroll code
        setScrolling(true);
      }
      setScrollTop(crntPos <= 0 ? 0 : crntPos);
    };

    scroller.scrollTo('root', {
      duration: 1500,
      delay: 100,
      smooth: true,
      containerId: 'root',
    });

    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scrollTop]);

  return (
    scrolling && (
      <Link className={'backToTop show'} to={'root'} spy={true} smooth={true} activeClass={'active'}>
        <ImageComponent srcFile={GoTop} className='back-to-top-icon' alt='back-to-top' />
      </Link>
    )
  );
};

export default ScrollTop;
